import React from "react";
import "./CSS/StoryBehind.css";
import storyImg from "./IMAGES/Luxury minimal chair (1).png"; 

const StoryBehind = () => {
  return (
    <section className="story">
      <div className="story-container">

        {/* LEFT IMAGE */}
        <div className="story-left">
          <img src={storyImg} alt="Story" />
        </div>

        {/* RIGHT CONTENT */}
        <div className="story-rights">
          <p className="story-tags">• The Story Behind the Name</p>

          <h1>
            A Name That <br />
            Carries Meaning <br />
            And Legacy
          </h1>

          <p className="story-texts">
            Our name is more than just an identity—it is a reflection of our
            roots, values, and vision. Inspired by tradition and driven by a
            passion for craftsmanship, it represents the journey of blending
            heritage with modern elegance. Every letter holds a story of
            dedication, culture, and timeless beauty that we aim to bring into
            every creation. It stands as a symbol of trust, quality, and pride,
            connecting generations through the art we cherish.
          </p>
        </div>

      </div>
    </section>
  );
};

export default StoryBehind;